riot.tag2('dealer-start-reservation-cta', '<a data-tracking="{trackingData}" href="{this.opts.dealerWebAddress}" class="acr-cta-btn is-dark" target="_blank"> <span> {text} </span> </a>', '', '', function(opts) {
    var trackingJSON = require('../../data/tracking-data');
    var self = this;
    var isTrackingFilled = false;
    var modelName = window.dealerLocator && window.dealerLocator.modelName
                    ? window.dealerLocator.modelName : '' ;
    var modelYear = window.dealerLocator && window.dealerLocator.modelYear
                    ? window.dealerLocator.modelYear : '' ;
    var startReservationLabel = `startReservation${modelName.toUpperCase()}${modelYear}`
    self.text = window.dealerLocator && window.dealerLocator.labels[startReservationLabel]
    ? window.dealerLocator.labels[startReservationLabel] : '';

    function setTrackingData() {
      var dealer = self.parent.opts.dealer;
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerCTA));
      jsonData.Dealer.selected_dealer_id = dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = dealer.Name;
      jsonData.Dealer.selected_dealer_address = dealer.Address + ', ' + dealer.City;
      jsonData.Dealer.selected_dealer_link = self.opts.dealerWebAddress;
      jsonData.Model = jsonData.Model ? jsonData.Model : {};
      jsonData.Model.model_name = modelName;
      jsonData.Model.model_year = modelYear;

      jsonData.dynamic_variables[0].search += 'results:[click text]';

      jsonData['Event Metadata'].action_type = 'cta';

      self.trackingData = JSON.stringify(jsonData);
    }

    self.on('update', function onUpdate() {
      if (self.parent.opts.dealer && !isTrackingFilled) {
        setTrackingData();
        isTrackingFilled = true;
      }
    });
});